import { render, staticRenderFns } from "./registerSectorStep1Page.vue?vue&type=template&id=392d5afa&scoped=true&"
import script from "./registerSectorStep1Page.vue?vue&type=script&lang=js&"
export * from "./registerSectorStep1Page.vue?vue&type=script&lang=js&"
import style0 from "./registerSectorStep1Page.vue?vue&type=style&index=0&id=392d5afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392d5afa",
  null
  
)

export default component.exports